import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[h3Truncate]',
  hostDirectives: [MatTooltip],
  host: {
    '[style.text-overflow]': '"ellipsis"',
    '[style.overflow]': '"hidden"',
    '[style.white-space]': '"nowrap"',
  },
})
export class TruncateDirective implements AfterViewInit {
  private readonly tooltip = inject(MatTooltip);
  private readonly elementRef = inject(ElementRef);

  ngAfterViewInit() {
    const isOverflowing =
      this.elementRef.nativeElement.scrollWidth >
      this.elementRef.nativeElement.clientWidth;

    if (isOverflowing) {
      this.tooltip.message = this.elementRef.nativeElement.innerText;
    }
  }
}
